import React from 'react'
import { InteractiveDialog, InstructionsPure, ButtonHLPure } from '../../pures'
import './modal-select-upload-method.css'

/**
 * @function CameraIcon
 * @description Icono SVG de cámara para la opción de captura de foto
 * @returns {JSX.Element}
 */
const CameraIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="12" width="40" height="28" rx="4" stroke="#2c353c" strokeWidth="2.5" fill="none" />
    <circle cx="24" cy="26" r="8" stroke="#2c353c" strokeWidth="2.5" fill="none" />
    <circle cx="24" cy="26" r="4" stroke="#2c353c" strokeWidth="1.5" fill="none" />
    <path d="M16 12L18 8H30L32 12" stroke="#2c353c" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
    <circle cx="36" cy="18" r="2" fill="#2c353c" />
  </svg>
)

/**
 * @function FileIcon
 * @description Icono SVG de documento para la opción de carga de archivo
 * @returns {JSX.Element}
 */
const FileIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6H30L38 14V42H12C10.8954 42 10 41.1046 10 40V8C10 6.89543 10.8954 6 12 6Z" stroke="#2c353c" strokeWidth="2.5" fill="none" />
    <path d="M30 6V14H38" stroke="#2c353c" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
    <line x1="16" y1="22" x2="32" y2="22" stroke="#2c353c" strokeWidth="2" />
    <line x1="16" y1="28" x2="32" y2="28" stroke="#2c353c" strokeWidth="2" />
    <line x1="16" y1="34" x2="26" y2="34" stroke="#2c353c" strokeWidth="2" />
  </svg>
)

/**
 * @typedef {Object} ModalSelectUploadMethodProps
 * @property {function} t - Función de traducción i18n
 * @property {function} onSelectCamera - Callback al seleccionar captura con cámara
 * @property {function} onSelectFile - Callback al seleccionar carga de archivo
 * @property {function} onClose - Callback para cerrar el modal
 */

/**
 * @function ModalSelectUploadMethod
 * @description Modal con dos opciones para cargar documento de identidad:
 * capturar foto con cámara o cargar archivo manualmente.
 * @param {ModalSelectUploadMethodProps} props
 * @returns {JSX.Element}
 */
const ModalSelectUploadMethod = ({ t, onSelectCamera, onSelectFile, onClose }) => {
  return (
    <InteractiveDialog
      title={t('uploadIdentityDocument.modals.select.title')}
      onClose={onClose}
      dialogSize="M"
      CustomButtons={
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', padding: '0 20px 0 0' }}>
          <ButtonHLPure
            nameBtn={t('button.cancel')}
            onClickBtn={onClose}
          />
        </div>
      }
    >
      <div className="modalSelectUploadMethod-instructions">
        <InstructionsPure
          instructions={[t('uploadIdentityDocument.modals.select.instructions')]}
        />
      </div>

      <div className="modalSelectUploadMethod-options">
        <div
          className="modalSelectUploadMethod-card"
          onClick={onSelectCamera}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onSelectCamera()}
        >
          <div className="modalSelectUploadMethod-card-icon">
            <CameraIcon />
          </div>
          <div className="modalSelectUploadMethod-card-content">
            <p className="modalSelectUploadMethod-card-title">
              {t('uploadIdentityDocument.modals.select.capturePhoto')}
            </p>
            <p className="modalSelectUploadMethod-card-description">
              {t('uploadIdentityDocument.modals.select.capturePhoto.description')}
            </p>
          </div>
        </div>

        <div
          className="modalSelectUploadMethod-card"
          onClick={onSelectFile}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onSelectFile()}
        >
          <div className="modalSelectUploadMethod-card-icon">
            <FileIcon />
          </div>
          <div className="modalSelectUploadMethod-card-content">
            <p className="modalSelectUploadMethod-card-title">
              {t('uploadIdentityDocument.modals.select.uploadFile')}
            </p>
            <p className="modalSelectUploadMethod-card-description">
              {t('uploadIdentityDocument.modals.select.uploadFile.description')}
            </p>
          </div>
        </div>
      </div>
    </InteractiveDialog>
  )
}

export { ModalSelectUploadMethod as default }
